export const GET_INVOICE_INFO = 'GET_INVOICE_INFO'
export const RESET_INVOICE_INFO = 'RESET_INVOICE_INFO'
export const GET_INVOICE_INFO_SUCCESS = 'GET_INVOICE_INFO_SUCCESS'
export const GET_INVOICE_INFO_RESET = 'GET_INVOICE_INFO_RESET'
export const GET_INVOICE_INFO_ERROR = 'GET_INVOICE_INFO_ERROR'
export const SET_ACTIVE_ID = 'SET_ACTIVE_ID'